import React, {useState} from 'react';
import {getCurrentMonth} from '@unthinkable/react-filters/src/DateUtility';
import {
  GroupFilter,
  PeriodRangeFilter,
  SearchFilter,
} from '../../../components/filter/Filters';
import {TabView} from '../../../components/tab';
import {useFilter} from '../../../controllers/useFilter';
import {useAppStateContext} from '../../../providers/AppState';
import {
  RFRDeliveryOwnerWiseActiveSuccessList,
  RFRDeliveryOwnerWiseActiveSuccessListForDO,
  RFRDeliveryOwnerWiseSuccessList,
  RFRDeliveryOwnerWiseSuccessListForDo,
  RFRMentorWiseActiveSuccessList,
  RFRMentorWiseSuccessList,
  RFRMentorWisecomparitiveSuccessList,
  RFRResourceWiseActiveSuccessList,
  RFRResourceWiseSuccessList,
  RFRResourceWiseSuccessScheduledList,
} from './RFRResourceList';
import {Button} from '../../../components/button/Button';

export const RFRResourceWise = props => {
  let {route: {params} = {}} = props;
  const {onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });

  const {download} = useAppStateContext();
  const {params: filterParams = {}} = filterValues || {};
  const tabs = {
    allocation: {
      label: 'RFR Resource',
      view: (
        <RFRResourceWiseSuccessList
          searchValue={searchValue}
          params={params}
          filterParams={filterParams}
        />
      ),
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/resource-wise-success',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <PeriodRangeFilter
          onChangeFilter={onChangeFilter}
          filterValues={filterValues}
        />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <Button
          text="Download"
          onPress={() => {
            download({
              uri: `/rfr/resoure-wise/export`,
              props: {
                ...params,
                ...filterParams,
              },
            });
          }}
        />,
      ]}
    />
  );
};

export const RFRMentorWise = props => {
  let {route: {params} = {}} = props;
  const {onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });

  const {download} = useAppStateContext();
  const {params: filterParams = {}} = filterValues || {};
  const tabs = {
    allocation: {
      label: 'Mentor Wise Opportunity',
      view: (
        <RFRMentorWiseSuccessList
          searchValue={searchValue}
          params={params}
          filterParams={filterParams}
        />
      ),
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/mentor-wise-success',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <PeriodRangeFilter
          onChangeFilter={onChangeFilter}
          filterValues={filterValues}
        />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <Button
          text="Download"
          onPress={() => {
            download({
              uri: `/rfr/mentor-wise/export`,
              props: {
                ...params,
                ...filterParams,
              },
            });
          }}
        />,
      ]}
    />
  );
};

export const RFRResourceWiseComparitiveReport = props => {
  let {route: {params} = {}} = props;
  const {onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });

  const {download} = useAppStateContext();
  const {params: filterParams = {}} = filterValues || {};
  const tabs = {
    allocation: {
      label: 'RFR Resource',
      view: (
        <RFRResourceWiseSuccessScheduledList
          searchValue={searchValue}
          params={params}
          filterParams={filterParams}
        />
      ),
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/resource-wise-comparitive-success',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <PeriodRangeFilter
          onChangeFilter={onChangeFilter}
          filterValues={filterValues}
        />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <Button
          text="Download"
          onPress={() => {
            download({
              uri: `/rfr/resoure-wise-compartitve/export`,
              props: {
                ...params,
                ...filterParams,
              },
            });
          }}
        />,
      ]}
    />
  );
};

export const RFRMentorWiseComparitive = props => {
  let {route: {params} = {}} = props;
  const {onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });

  const {download} = useAppStateContext();
  const {params: filterParams = {}} = filterValues || {};
  const tabs = {
    allocation: {
      label: 'Mentor Wise Opportunity',
      view: (
        <RFRMentorWisecomparitiveSuccessList
          searchValue={searchValue}
          params={params}
          filterParams={filterParams}
        />
      ),
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/mentor-wise-comparitive-success',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <PeriodRangeFilter
          onChangeFilter={onChangeFilter}
          filterValues={filterValues}
        />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <Button
          text="Download"
          onPress={() => {
            download({
              uri: `/rfr/mentor-wise-comparitive/export`,
              props: {
                ...params,
                ...filterParams,
              },
            });
          }}
        />,
      ]}
    />
  );
};

export const RFRResourceWiseNew = props => {
  let {route: {params} = {}} = props;
  const {onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });

  const {download} = useAppStateContext();
  const {params: filterParams = {}} = filterValues || {};
  const tabs = {
    Active: {
      label: 'Active',
      view: (
        <RFRResourceWiseActiveSuccessList
          searchValue={searchValue}
          params={params}
          // filterParams={filterParams}
        />
      ),
      actions: [
        // <PeriodRangeFilter
        //   onChangeFilter={onChangeFilter}
        //   filterValues={filterValues}
        // />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        // <Button
        //   text="Download"
        //   onPress={() => {
        //     download({
        //       uri: `/rfr/resoure-wise/export`,
        //       props: {
        //         ...params,
        //         ...filterParams,
        //       },
        //     });
        //   }}
        // />,
      ],
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/resource-wise-active-interviews',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
    Closed: {
      label: 'Closed',
      view: (
        <RFRResourceWiseSuccessList
          searchValue={searchValue}
          params={params}
          filterParams={filterParams}
        />
      ),
      actions: [
        <PeriodRangeFilter
          onChangeFilter={onChangeFilter}
          filterValues={filterValues}
        />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <Button
          text="Download"
          onPress={() => {
            download({
              uri: `/rfr/resoure-wise/export`,
              props: {
                ...params,
                ...filterParams,
              },
            });
          }}
        />,
      ],
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/resource-wise-success',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      // actions={[
      //   <PeriodRangeFilter
      //     onChangeFilter={onChangeFilter}
      //     filterValues={filterValues}
      //   />,
      //   <SearchFilter
      //     value={searchValue}
      //     onChangeFilter={onChangeFilter}
      //     placeholder="Search"
      //   />,
      //   <Button
      //     text="Download"
      //     onPress={() => {
      //       download({
      //         uri: `/rfr/resoure-wise/export`,
      //         props: {
      //           ...params,
      //           ...filterParams,
      //         },
      //       });
      //     }}
      //   />,
      // ]}
    />
  );
};

export const RFRMentorWiseNew = props => {
  let {route: {params} = {}} = props;
  const {onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });

  const {download} = useAppStateContext();
  const {params: filterParams = {}} = filterValues || {};
  const tabs = {
    active: {
      label: 'Active',
      view: (
        <RFRMentorWiseActiveSuccessList
          searchValue={searchValue}
          params={params}
          filterParams={filterParams}
        />
      ),
      actions: [
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        // <Button
        //   text="Download"
        //   onPress={() => {
        //     download({
        //       uri: `/rfr/mentor-wise/export`,
        //       props: {
        //         ...params,
        //         ...filterParams,
        //       },
        //     });
        //   }}
        // />,
      ],
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/mentor-wise-success-interview',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
    closed: {
      label: 'Closed',
      view: (
        <RFRMentorWiseSuccessList
          searchValue={searchValue}
          params={params}
          filterParams={filterParams}
        />
      ),
      actions: [
        <PeriodRangeFilter
          onChangeFilter={onChangeFilter}
          filterValues={filterValues}
        />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <Button
          text="Download"
          onPress={() => {
            download({
              uri: `/rfr/mentor-wise/export`,
              props: {
                ...params,
                ...filterParams,
              },
            });
          }}
        />,
      ],
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/mentor-wise-success',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      // actions={[
      //   <PeriodRangeFilter
      //     onChangeFilter={onChangeFilter}
      //     filterValues={filterValues}
      //   />,
      //   <SearchFilter
      //     value={searchValue}
      //     onChangeFilter={onChangeFilter}
      //     placeholder="Search"
      //   />,
      //   <Button
      //     text="Download"
      //     onPress={() => {
      //       download({
      //         uri: `/rfr/mentor-wise/export`,
      //         props: {
      //           ...params,
      //           ...filterParams,
      //         },
      //       });
      //     }}
      //   />,
      // ]}
    />
  );
};

export const RFRDeliveryOwnerWiseNew = props => {
  let {route: {params} = {}} = props;
  const {onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });

  const {download} = useAppStateContext();
  const {params: filterParams = {}} = filterValues || {};
  const tabs = {
    Active: {
      label: 'Active',
      view: (
        <RFRDeliveryOwnerWiseActiveSuccessList
          searchValue={searchValue}
          params={params}
          // filterParams={filterParams}
        />
      ),
      actions: [
        // <PeriodRangeFilter
        //   onChangeFilter={onChangeFilter}
        //   filterValues={filterValues}
        // />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        // <Button
        //   text="Download"
        //   onPress={() => {
        //     download({
        //       uri: `/rfr/resoure-wise/export`,
        //       props: {
        //         ...params,
        //         ...filterParams,
        //       },
        //     });
        //   }}
        // />,
      ],
      eventSourceId: 'practiceWiseOpportunity',
      // api: '/rfr/resource-wise-active-interviews',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
    Closed: {
      label: 'Closed',
      view: (
        <RFRDeliveryOwnerWiseSuccessList
          searchValue={searchValue}
          params={params}
          filterParams={filterParams}
        />
      ),
      actions: [
        <PeriodRangeFilter
          onChangeFilter={onChangeFilter}
          filterValues={filterValues}
        />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <Button
          text="Download"
          onPress={() => {
            download({
              uri: `/rfr/resoure-wise/export`,
              props: {
                ...params,
                ...filterParams,
              },
            });
          }}
        />,
      ],
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/resource-wise-success',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      // actions={[
      //   <PeriodRangeFilter
      //     onChangeFilter={onChangeFilter}
      //     filterValues={filterValues}
      //   />,
      //   <SearchFilter
      //     value={searchValue}
      //     onChangeFilter={onChangeFilter}
      //     placeholder="Search"
      //   />,
      //   <Button
      //     text="Download"
      //     onPress={() => {
      //       download({
      //         uri: `/rfr/resoure-wise/export`,
      //         props: {
      //           ...params,
      //           ...filterParams,
      //         },
      //       });
      //     }}
      //   />,
      // ]}
    />
  );
};

export const RFRDeliveryOwnerWiseNewDeliveryOwner = props => {
  let {route: {params} = {}} = props;
  const {onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });

  const {download} = useAppStateContext();
  const {params: filterParams = {}} = filterValues || {};
  const tabs = {
    Active: {
      label: 'Active',
      view: (
        <RFRDeliveryOwnerWiseActiveSuccessList
          searchValue={searchValue}
          params={params}
          // filterParams={filterParams}
        />
      ),
      actions: [
        // <PeriodRangeFilter
        //   onChangeFilter={onChangeFilter}
        //   filterValues={filterValues}
        // />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        // <Button
        //   text="Download"
        //   onPress={() => {
        //     download({
        //       uri: `/rfr/resoure-wise/export`,
        //       props: {
        //         ...params,
        //         ...filterParams,
        //       },
        //     });
        //   }}
        // />,
      ],
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/resource-wise-active-interviews',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
    Closed: {
      label: 'Closed',
      view: (
        <RFRDeliveryOwnerWiseSuccessList
          searchValue={searchValue}
          params={params}
          filterParams={filterParams}
        />
      ),
      actions: [
        <PeriodRangeFilter
          onChangeFilter={onChangeFilter}
          filterValues={filterValues}
        />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <Button
          text="Download"
          onPress={() => {
            download({
              uri: `/rfr/resoure-wise/export`,
              props: {
                ...params,
                ...filterParams,
              },
            });
          }}
        />,
      ],
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/resource-wise-success',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      // actions={[
      //   <PeriodRangeFilter
      //     onChangeFilter={onChangeFilter}
      //     filterValues={filterValues}
      //   />,
      //   <SearchFilter
      //     value={searchValue}
      //     onChangeFilter={onChangeFilter}
      //     placeholder="Search"
      //   />,
      //   <Button
      //     text="Download"
      //     onPress={() => {
      //       download({
      //         uri: `/rfr/resoure-wise/export`,
      //         props: {
      //           ...params,
      //           ...filterParams,
      //         },
      //       });
      //     }}
      //   />,
      // ]}
    />
  );
};

export const RFRDeliveryOwnerWiseNewDeliveryOwnerWise = props => {
  let {route: {params} = {}} = props;
  const {onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });

  const {
    download,
    user: {employee: employeeId},
  } = useAppStateContext();
  const {params: filterParams = {}} = filterValues || {};
  const tabs = {
    Active: {
      label: 'Active',
      view: (
        <RFRDeliveryOwnerWiseActiveSuccessListForDO
          searchValue={searchValue}
          params={params}
          // filterParams={filterParams}
        />
      ),
      actions: [
        // <PeriodRangeFilter
        //   onChangeFilter={onChangeFilter}
        //   filterValues={filterValues}
        // />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        // <Button
        //   text="Download"
        //   onPress={() => {
        //     download({
        //       uri: `/rfr/resoure-wise/export`,
        //       props: {
        //         ...params,
        //         ...filterParams,
        //       },
        //     });
        //   }}
        // />,
      ],
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/resource-wise-active-interviews',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
    Closed: {
      label: 'Closed',
      view: (
        <RFRDeliveryOwnerWiseSuccessListForDo
          searchValue={searchValue}
          params={params}
          filterParams={filterParams}
        />
      ),
      actions: [
        <PeriodRangeFilter
          onChangeFilter={onChangeFilter}
          filterValues={filterValues}
        />,
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <Button
          text="Download"
          onPress={() => {
            download({
              uri: `/rfr/resoure-wise/export`,
              props: {
                ...params,
                ...filterParams,
              },
            });
          }}
        />,
      ],
      eventSourceId: 'practiceWiseOpportunity',
      api: '/rfr/resource-wise-success',
      search: searchValue,
      searchFields: 'name',
      params: {...params, ...filterParams},
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      // actions={[
      //   <PeriodRangeFilter
      //     onChangeFilter={onChangeFilter}
      //     filterValues={filterValues}
      //   />,
      //   <SearchFilter
      //     value={searchValue}
      //     onChangeFilter={onChangeFilter}
      //     placeholder="Search"
      //   />,
      //   <Button
      //     text="Download"
      //     onPress={() => {
      //       download({
      //         uri: `/rfr/resoure-wise/export`,
      //         props: {
      //           ...params,
      //           ...filterParams,
      //         },
      //       });
      //     }}
      //   />,
      // ]}
    />
  );
};
